<div class="bannerback">
    <app-nav></app-nav>
</div>

<app-skelitions [hidden]="!skeleton" [value]="6" class="mb-2"></app-skelitions>

<p-messages [(value)]="messages" [enableService]="false"></p-messages>
<app-assign-users [selectionData]="currentCourse.attendees" (selectedUsersList)="addAttendees($event)"
    [userFetchUrl]="'user'" *ngIf="showingSelectUser && currentCourse"></app-assign-users>
<div class="bg-iimg" *ngIf="!showingSelectUser">
    <div class="container-fluid">
        <div class="container">
            <!-- Request cards start -->
            <section [hidden]="createTrainingModal || viewDetails">
                <div class="d-flex justify-content-between pt-5">
                    <div class="d-flex">
                        <img class="img-icon" src="../../../../assets/icons/SBC/glass-paper-pen.svg" alt="loading">
                        <h2 class="font-600 color bottom-line p-0 dark-blue"> {{"training courses"| translator}}</h2>
                    </div>
                   
                    <!-- *ngIf="hasPermission('COURSE','c')" -->
                   
                    <button [hidden]="createTrainingModal" (click)="createTrainingModal = true"
                        class="create-training-btn mx-2">{{"Create a training course"| translator}}<i class="pi pi-plus-circle mx-2"></i></button>
                </div>
                <!-- breadcrumb -->
                <div class="d-flex flex-row align-items-center flex-wrap my-3 mx-3">
                    <span class="d-flex align-items-center">
                        <span class="custom-bredcrum-btn d-flex align-items-center">
                            {{"Administration"| translator}}
                        </span>
                        <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
                    </span>
                    <span class="d-flex align-items-center">
                        <span class="custom-bredcrum-btn font-600 d-flex align-items-center">
                            {{"training courses"| translator}}
                        </span>
                    </span>
                </div>
                <!-- breadcrumb end -->
                <div class="row">
                    <h4 class="font-600 color mb-3"><i class="pi pi-filter  ml-2 mr-2 course-icon-ui"></i>{{"filter"| translator}}</h4>
                    <div class="row row-bg m-0">
                        <div class="col-lg-4 col-md-6 col-12">
                            <button [ngClass]="pending ? 'course-btn-ui-active' : ''" (click)="filterByStatus('')"
                                class="course-btn-ui my-1 mx-1 font-600"><i
                                    class="pi pi-arrow-circle-left mx-2"></i>{{"pending"| translator}}</button>
                        </div>
                        <div class="col-lg-4 col-md-6 col-12">
                            <button [ngClass]="ongoing ? 'course-btn-ui-active' : ''"
                                (click)="filterByStatus('ONGOING')" class="course-btn-ui my-1 mx-1 font-600"><i
                                    class="fa fa-hourglass-start mx-2"></i>{{"Current"| translator}} </button>
                        </div>
                        <div class="col-lg-4 col-md-6 col-12">
                            <button (click)="filterByStatus('COMPLETE')" class="course-btn-ui my-1 mx-1 font-600"
                                [ngClass]="complete ? 'course-btn-ui-active' : ''"><i
                                    class="fa fa-check mx-2"></i>{{"Complete"| translator}}</button>
                        </div>
                    </div>

                    <div *ngFor="let course of courseData" class="col-lg-4 col-md-6 col-sm-12 col-12 my-3">
                        <div class="shaddow">
                            <p-card class="new-card" [header]="course.title">
                                <ng-template pTemplate="header">
                                    <div class="image-card">
                                        <img *ngIf="course.image" class="image"
                                            [src]="GlobalConstants.staticFilesURL+course.image" />
                                        <img *ngIf="!course.image" class="image"
                                            src="../../../../assets/bg/alt-img.png" />
                                        <!-- this is multiple code for mobile and desktop view -->
                                        <div class="status-completed mobile">{{
                                            statusByDate(course?.start_date,course?.end_date)}}</div>
                                        <span class="pos-rel">
                                            <span class="start-your-project desktop">
                                                <span class="chit-txt">{{
                                                    statusByDate(course?.start_date,course?.end_date)}}</span>
                                            </span>
                                        </span>
                                        <!-- this is multiple code for mobile and desktop view END -->
                                    </div>
                                </ng-template>
                                <!-- <div class="flex-column"> -->
                                <!-- <span class="description-responsive">
                                    <span class="desc-heading">{{"the description"| translator}}</span>
                                    <span [innerHTML]="course?.description | safeHTML"></span>
                                </span> -->
                                <!-- </div>  *ngIf="hasPermission('COURSE','u')" -->
                                <ng-template pTemplate="footer">
                                    <div class="d-flex gap-3" >
                                        <p-button label='{{"View details"| translator}}' icon="pi pi-eye" (onClick)="courseDetail(course ,viewDetails)"
                                        styleClass="create-training-btn"></p-button>
                                        <p-button label='{{"Add participants"| translator}}' (onClick)="openAttendeesModal(course)"
                                            icon="pi pi-plus" styleClass="create-training-btn"></p-button>
                                    </div>
                                </ng-template>
                            </p-card>
                        </div>
                    </div>

                    <!-- Old code  -->
                    <!-- <div *ngFor="let course of courseData" class="col-lg-4 col-md-6 col-sm-12 col-12 my-3">
                   <p-card class="card-shaddow" [header]="course.title">
                       <ng-template pTemplate="header">
                        <div class="img-card-view">
                            <img class="img-response" alt="Card" [src]="GlobalConstants.staticFilesURL+course.image"/>
                        </div>
                       </ng-template>
                       <div class="flex-column">
                           <span class="description-responsive">
                            <span class="desc-heading">{{"the description"| translator}}</span>
                        <span [innerHTML]="course?.description | safeHTML"></span>
                    </span>
                    </div>
                       <ng-template pTemplate="footer">
                        <div class="d-flex justify-content-center">
                        <div class="">
                            <button  (click)="completeCourseObject = course; viewDetailss = true" class="create-training-btn mx-2">{{"View details"| translator}} <i class="pi pi-eye mx-2"></i></button>
                        </div>
                        </div>
                       </ng-template>
                   </p-card>
               </div> -->
                    <app-no-data *ngIf="courseData.length <= 0 "></app-no-data>
                </div>
            </section>
            <!-- Request cards end -->
            <section [hidden]="!createTrainingModal">
                <app-create-course></app-create-course>
            </section>





        </div>
    </div>
    <app-show-detail *ngIf="viewDetails" [courseDetails]="completeCourseObject"></app-show-detail>

    <!-- <p-dialog [blockScroll]="true" [draggable]="false"header="create training" [(visible)]="createTrainingModal" [maximizable]="true" [breakpoints]="{ '960px': '75vw' }" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
</p-dialog> -->
    <!-- <app-view-course-details *ngIf="completeCourseObject" [data]="completeCourseObject"></app-view-course-details> -->
    <app-footer></app-footer>

    <!-- Edit Rejection Modal -->
    <!-- <div class="card flex justify-content-center">
    <p-dialog [blockScroll]="true" [draggable]="false"header="{{"Details of the course"| translator}}" [(visible)]="viewDetailss" [style]="{margin: '0rem 1rem'}" [maximizable]="true">
       
        <app-view-course-details *ngIf="completeCourseObject" [data]="completeCourseObject"></app-view-course-details>


        <ng-template pTemplate="footer">
            <p-button icon="pi pi-times-circle" (click)="viewDetailss = false" label="{{"Exit"| translator}}" styleClass="p-button-text"></p-button>
        </ng-template>

    </p-dialog>
</div> -->


    <!-- SESSION /Survey/Assessment Selection Modal -->

    <p-dialog [blockScroll]="true" [draggable]="false"header='{{"Create a workshop"| translator}}' [(visible)]="openProgramModal" [style]="{width: '50vw' , minHeight:'40vh'}"
        [maximizable]="true">
        <form *ngIf="openProgramModal" class="custom-bg-1 h-380px" [formGroup]="createProgramForm"
            (ngSubmit)="onSubmitProgram(type)" novalidate>
            <div class="card-scroll">
                <div class="row">

                    <div class="col-lg-12">
                        <label class="block text-900 font-medium mb-2 font-bold" for="title">{{"the address"| translator}}</label>
                        <input type="text" id="title" placeholder='{{"Please write the address"| translator}}' formControlName="title"
                            pInputText class="w-full mb-3">
                        <div class="error"
                            *ngIf="createProgramForm.controls['title'].invalid && (createProgramForm.controls['title'].dirty || createProgramForm.controls['title'].touched)">
                            <div *ngIf="createProgramForm.controls['title'].errors?.['required']">{{"The title is required"| translator}}
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12">
                        <label class="block text-900 font-medium mb-2 font-bold" for="start_time">{{"the date"| translator}}</label>
                        <p-calendar formControlName="date"></p-calendar>
                    </div>

                    <div class="col-lg-6">
                        <label class="block text-900 font-medium mb-2 font-bold" for="start_time">{{"Starting time"| translator}}</label>
                        <input type="time" id="start_time" placeholder="Please enter start time"
                            formControlName="start_time" pInputText class="w-full mb-3">
                        <div class="error"
                            *ngIf="createProgramForm.controls['start_time'].invalid && (createProgramForm.controls['start_time'].dirty || createProgramForm.controls['start_time'].touched)">
                            <div *ngIf="createProgramForm.controls['start_time'].errors?.['required']">
                                {{"The start time is required"| translator}}
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <label class="block text-900 font-medium mb-2 font-bold" for="end time">{{"end time"| translator}}</label>
                        <input type="time" id="end_time" placeholder="Please enter end time" formControlName="end_time"
                            pInputText class="w-full mb-3">
                        <div class="error"
                            *ngIf="createProgramForm.controls['end_time'].invalid && (createProgramForm.controls['end_time'].dirty || createProgramForm.controls['end_time'].touched)">
                            <div *ngIf="createProgramForm.controls['end_time'].errors?.['required']">End
                                {{"Time to finish is required"| translator}}</div>
                        </div>
                    </div>

                    <!-- Assessment -->
                    <section *ngIf="assessment">

                        <p-card div class="col-12" *ngFor="let assessment of assessments"
                            [header]="assessment.assessmentTitle" [subheader]="assessment.assessmentType">
                            <p>
                                {{assessment.description}}
                            </p>
                            <ng-template pTemplate="footer">
                                <p-button label='{{"Choose"| translator}}' (onClick)="sectionTypeIdHolder = assessment"
                                    icon="pi pi-check"></p-button>
                            </ng-template>
                        </p-card>
                    </section>

                    <!-- Survey -->
                    <section *ngIf="survey">

                        <p-card class="col-12" *ngFor="let survey of surveys" [header]="survey.surveyTitle"
                            [subheader]="survey.surveyTitle">
                            <p>
                                {{survey.description}}
                            </p>
                            <ng-template pTemplate="footer">
                                <p-button label='{{"Choose"| translator}}' (onClick)="sectionTypeIdHolder = survey"
                                    icon="pi pi-check"></p-button>
                            </ng-template>
                        </p-card>
                    </section>



                    <section *ngIf="createSession">
                        <div class="col-9">
                            <label class="block text-900 font-medium mb-2 font-bold" for="trainer">{{"the coach"| translator}}</label>
                            <p-dropdown styleClass="w-100" [options]="trainers" formControlName="trainer"
                                optionLabel="name" [filter]="true" filterBy="name" [showClear]="true"
                                placeholder='{{"Choose the coach"| translator}}'>
                                <!-- <ng-template pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2" *ngIf="selectedCountry">
                                <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" [class]="'flag flag-' + selectedCountry.code.toLowerCase()" style="width: 18px"/>
                                <div>{{ selectedCountry.name }}</div>
                            </div>
                        </ng-template> -->
                                <ng-template let-trainers pTemplate="item">
                                    <div class="flex align-items-center gap-2">
                                        <!-- <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" [class]="'flag flag-' + country.code.toLowerCase()" style="width: 18px"/> -->
                                        <div>{{ trainers.name }}</div>
                                    </div>
                                </ng-template>
                            </p-dropdown>
                            <div class="error"
                                *ngIf="createProgramForm.controls['trainer'].invalid && (createProgramForm.controls['trainer'].dirty || createProgramForm.controls['trainer'].touched)">
                                <div *ngIf="createProgramForm.controls['trainer'].errors?.['required']">{{"The trainer is required"| translator}}
                                </div>
                                <!-- <div *ngIf="createProgramForm.controls['title'].errors?.['pattern']">{{"Please write in Arabic"| translator}}</div> -->
                            </div>
                        </div>
                        <div class="col-3">
                            <label class="block text-900 font-medium mb-2 font-bold" for="trainer">{{"online?"| translator}}</label>
                            <p-checkbox formControlName="is_online" [binary]="true" inputId="binary"></p-checkbox>
                        </div>

                        <div *ngIf="createProgramForm.get('is_online').value" class="col-3">
                            <label class="block text-900 font-medium mb-2 font-bold" for="trainer">{{"is video" | translator}}</label>
                            <p-checkbox formControlName="is_video" [binary]="true" inputId="binary"></p-checkbox>
                        </div>

                        <div *ngIf="createProgramForm.get('is_online').value && !createProgramForm.get('is_video').value"
                            class="col-12">
                            <label class="block text-900 font-medium mb-2 font-bold" for="zoom_url">{{"Workshop link"| translator}}
                                {{"the job"| translator}}</label>
                            <input styleClass="w-100" class="w-100" type="text" id="zoom_url"
                                placeholder='{{"Paste the link here"| translator}}' formControlName="zoom_url" pInputText class="w-full mb-3">
                        </div>

                        <div *ngIf="createProgramForm.get('is_video').value" class="col-12">
                            <label class="block text-900 font-medium mb-2 font-bold" for="video_url">{{"Link"| translator}}
                                {{"the video"| translator}}</label>
                            <!-- <input styleClass="w-100" class="w-100" type="text" id="video_url" placeholder="{{"Paste the link here"| translator}}"
                        formControlName="video_url" pInputText class="w-full mb-3"> -->

                            <a class="doc-view" [hidden]="createProgramForm.get('video_url').value == ''"
                                target="_blank"
                                [href]="GlobalConstants.staticFilesURL+createProgramForm.get('video_url').value">
                                <i [hidden]="createProgramForm.get('video_url').value == ''"
                                    class="pi pi-file mx-2"></i>{{"Add a file"| translator}}
                            </a>
                            <p-fileUpload mode="basic" chooseLabel="Choose" name="file" [url]="apilink+'file/data'"
                                [auto]="true" chooseLabel="Add File" [maxFileSize]="100000000"
                                (onUpload)="addVideo($event.originalEvent.body.data)"></p-fileUpload>


                        </div>



                        <section *ngIf="!createProgramForm.get('is_online').value">
                            <p-divider align="left">
                                <div class="inline-flex align-items-center">
                                    <i class="pi pi-map-marker ml-2 mr-2"></i>
                                    <b> {{"the address"| translator}} </b>
                                </div>
                            </p-divider>

                            <div class="col-12">
                                <label class="block text-900 font-medium mb-2 font-bold" for="houseNumber">{{"Title"| translator}}
                                    {{"Headquarters address"| translator}}</label>
                                <input styleClass="w-100" class="w-100" type="text" id="houseNumber"
                                    placeholder='{{"Please write the full address"| translator}}' formControlName="houseNumber" pInputText
                                    class="w-full mb-3">
                                <div class="error"
                                    *ngIf="createProgramForm.controls['houseNumber'].invalid && (createProgramForm.controls['houseNumber'].dirty || createProgramForm.controls['houseNumber'].touched)">
                                    <div *ngIf="createProgramForm.controls['houseNumber'].errors?.['required']">{{"the name"| translator}}
                                        {{"required"| translator}}
                                    </div>
                                    <!-- <div *ngIf="createProgramForm.controls['houseNumber'].errors?.['pattern']">{{"Please write in Arabic"| translator}}</div> -->

                                </div>
                            </div>
                            <!-- pattern="[\u0600-\u06FF\s]+" -->
                            <div class="col-12">
                                <label class="block text-900 font-medium mb-2 font-bold" for="">{{"Location Link" | translator}}</label>
                                <input styleClass="w-100" type="text" id="street" placeholder="url..."
                                    formControlName="street" pInputText class="w-full mb-3">
                                <div class="error"
                                    *ngIf="createProgramForm.controls['street'].invalid && (createProgramForm.controls['street'].dirty || createProgramForm.controls['street'].touched)">
                                    <div *ngIf="createProgramForm.controls['street'].errors?.['required']">{{"Link" | translator}}</div>
                                    <!-- <div *ngIf="createProgramForm.controls['street'].errors?.['pattern']">{{"Please write in Arabic"| translator}}</div> -->
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <label class="block text-900 font-medium mb-2 font-bold" for="city">{{"City"| translator}} </label>
                                <p-dropdown id="city" [options]="city" placeholder='{{"Choose the city"| translator}}' formControlName="city"
                                    styleClass=" sstarabic w-100">
                                    <ng-template let-item pTemplate="item">
                                        <i [ngClass]="item.icon"></i>
                                        {{item.label}}
                                    </ng-template>
                                </p-dropdown>
                            </div>
                        </section>

                    </section>

                </div>
            </div>
            <span>
                <button type="button" (click)="onSubmitProgram(type)" pButton pRipple
                    [disabled]="!createProgramForm.valid" label=' {{"OK"| translator}} ' icon="pi pi-user-edit"
                    class="w-full mb-ten"></button>
            </span>
        </form>
    </p-dialog>
    <!-- End SESSION Selection Modal -->

</div>